/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";
import { servicereference } from '../ehr/subs/servicereference';

export class servicepaymentreference extends servicereference {
  amount: number = 0.0;
  coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  description: string = "";

  constructor() {
    super();
  }

  gettablename(): string {
    return "SERVICE_PAYMENT_REFERENCE";
  }
}
